// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { ModulationsSummary } from '../../common'

// NOTE: although this is a cell's custom rendering function,
// we don't export a parser for CSV exports.
// WHY you might ask?
// Because in the exported file, the rows are actually modulations, not radios.
// See ../scrubForCSV for more details.
// THIS IS A UNIQUE APPROACH AND SHOULD ONLY BE USED WITH CAUTION

const FormatModulation = ({ columnKey, rowData }) => {
  const { radioCode } = rowData
  const m = rowData[columnKey]

  // if there's only one modulation, just show its throughput
  if (m.length === 1) {
    return (
      <div>
        {m[0].throughput}
      </div>
    )
  }

  const tooltipContent = () => <ModulationsSummary modulations={m} />

  // otherwise display the modulations tooltip from project summary screen.
  return (
    <div className={'display-flex justify-content-start align-items-center'}>
      <p
        className={'tooltip-trigger-decoration show-decoration acm-tooltip-decoration'}
        data-class={'project-summary-tooltip tooltip-wrapper'}
        data-for={`lookup-tooltip-radio-modulations-${radioCode}`}
        data-tip={true}
        id={`lookup-tooltip-radio-modulations-${radioCode}-trigger`}>
        {'ACM'}
      </p>
      <ReactTooltip
        delayHide={200}
        effect={'solid'}
        id={`lookup-tooltip-radio-modulations-${radioCode}`}
        getContent={tooltipContent}
        place={'bottom'}
        type={'light'} />
    </div>
  )
}

FormatModulation.propTypes = {
  columnKey: string.isRequired,
  rowData: object.isRequired,
}

export default FormatModulation
